import LeadMagnetHeroTeaser from '@/components/leadmagnet/LeadMagnetHeroTeaser';

export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20professional%20corporate%20training%20environment%20with%20diverse%20business%20team%20collaborating%20in%20bright%20minimalist%20office%20space%2C%20holographic%20learning%20dashboard%20floating%2C%20warm%20golden%20and%20teal%20accents%2C%20clean%20Scandinavian%20interior%20design%2C%20soft%20natural%20lighting%20through%20large%20windows%2C%20sophisticated%20corporate%20aesthetic%2C%20abstract%20geometric%20knowledge%20visualization%2C%20editorial%20quality%20photography%20with%20elegant%20composition%20and%20professional%20atmosphere&width=1600&height=900&seq=staff-training-hero-01&orientation=landscape"
          alt="Обучение персонала компании — развитие сотрудников и корпоративное обучение"
          className="absolute top-1/2 left-1/2 w-[177.77777778vh] min-w-full h-[56.25vw] min-h-full -translate-x-1/2 -translate-y-1/2 object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/65 to-black/80"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center w-full pt-28 md:pt-24">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 md:mb-8 leading-[1.08] tracking-tight max-w-4xl mx-auto">
          Обучение персонала
        </h1>

        <p className="text-base md:text-lg text-white/85 mb-8 max-w-3xl mx-auto leading-relaxed">
          Большинство компаний вкладываются в рекламу, оборудование и автоматизацию, но забывают про главный ресурс — людей. Именно сотрудники определяют качество сервиса, уровень продаж, скорость развития компании и конкурентоспособность бизнеса.
        </p>
        <p className="text-base md:text-lg text-teal-300 mb-12 max-w-3xl mx-auto leading-relaxed font-semibold">
          Правильно организованное обучение персонала позволяет повысить производительность, удержать сотрудников и увеличить прибыль компании.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-4">
          <button onClick={() => scrollTo('contact')} className="group bg-teal-600 text-white px-8 py-4 rounded-xl text-base font-semibold hover:bg-teal-500 transition-all duration-300 transform hover:scale-[1.03] whitespace-nowrap cursor-pointer w-full sm:w-auto shadow-lg shadow-teal-600/25 hover:shadow-teal-600/40">
            Заказать обучение персонала
            <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform inline-block"></i>
          </button>
          <LeadMagnetHeroTeaser />
        </div>

        <p className="text-white/50 text-sm max-w-2xl mx-auto">
          Программу собираю под цели и процессы вашей компании, а не подгоняю готовый курс под всех.
        </p>

        <div className="mt-8 flex justify-center">
          <button onClick={() => scrollTo('why-strategic')} className="text-white/30 hover:text-white/70 transition-colors cursor-pointer animate-bounce">
            <i className="ri-arrow-down-line text-2xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}